import gql from 'graphql-tag';

export default gql`
  mutation resendVerificationEmail($email: EmailAddress!) {
    resendVerificationEmail(email: $email)
  }
`;
